import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AccessControlService} from '../services/access-control.service';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-organization-dashboard',
  templateUrl: './organization-dashboard.component.html',
  styleUrls: ['./organization-dashboard.component.css']
})
export class OrganizationDashboardComponent implements OnInit {
  applicationCount = 1;
  clientCount = 0;
  clients: any;
  displayedColumns: string[] = ['name', 'email', 'applications', 'status'];
  isLoading: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  noData: any;

  constructor(private router: Router, private accessControlService: AccessControlService) {
  }

  ngOnInit() {
    this.getDashboardItems();
  }

  addRoute() {
    this.router.navigate(['add-application'], {queryParams: {opt: 'add'}});
  }

  getDashboardItems() {
    this.isLoading = true;
    let orgId = localStorage.getItem('org_id');
    this.accessControlService.organizationDashboardItems(orgId).subscribe((response: any) => {
      if (!response.error) {
        this.applicationCount = response.data.applicationCount;
        this.clientCount = response.data.clients.length;
        this.dataSource = new MatTableDataSource<any>(response.data.clients);
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'name':
              return item._id.name;
            case 'email':
              return item._id.email;
            case 'application':
              return item._id.application;
            case 'status':
              return item._id.status;
            default:
              return item._id.name;
          }
        };
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.dataSource.filterPredicate = function (data, filter): boolean {
          return data.apps.toString().toLowerCase().includes(filter) || data._id.email.toLowerCase().includes(filter) || data._id.name.toLowerCase().includes(filter);
        };
        this.isLoading = false;
      } else {
        this.isLoading = false;
        alert(response.message);
      }


    }, error => {
      this.isLoading = false;
      alert(error.error);
    });
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
